import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  navBar,
  mainBody,
  about,
  experience,
  leadership,
  repos,
  awards,
  skills,
  getInTouch,
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import AboutMe from "./components/home/AboutMe";
import Project from "./components/home/Project";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Skills from "./components/home/Skills";
// import { Blog } from "./components/blog/Blog";
// import BlogPost from "./components/blog/BlogPost";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Awards from "./components/home/Awards.jsx";
import Experience from "./components/home/Experience";
import Leadership from "./components/home/Leadership";

const Home = React.forwardRef((props, ref) => {
  return (
    <>
      <MainBody
        gradient={mainBody.gradientColors}
        title={`${mainBody.firstName} ${mainBody.middleName} ${mainBody.lastName}`}
        message={mainBody.message}
        icons={mainBody.icons}
        ref={ref}
      />
      {about.show && (
        <AboutMe
          heading={about.heading}
          message={about.message}
          link={about.imageLink}
          imgSize={about.imageSize}
          resume={about.resume}
          education={about.education}
        />
      )}
      {experience.show && (
        <Experience
          heading={experience.heading}
          experienceList={experience.data}
        />
      )}
      {leadership.show && (
        <Leadership
          heading={leadership.heading}
          leadershipList={leadership.data}
        />
      )}
      {repos.show && (
        <Project
          heading={repos.heading}
          // username={repos.gitHubUsername}
          // length={repos.reposLength}
          specificRepos={repos.specificRepos}
        />
      )}
      {skills.show && (
        <Skills
          heading={skills.heading}
          languages={skills.languages}
          librariesFrameworks={skills.librariesFrameworks}
          otherSkills={skills.otherSkills}
        />
      )}
      {awards.show && (
        <Awards
          heading={awards.heading}
          message={awards.message}
          img={awards.images}
          imageSize={awards.imageSize}
        />
      )}
    </>
  );
});

const App = () => {
  const titleRef = React.useRef();

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
      {navBar.show && (
        <Navbar
          ref={titleRef}
          firstName={mainBody.firstName}
          about={about}
          experience={experience}
          leadership={leadership}
          repos={repos}
          skills={skills}
          awards={awards}
        />
      )}
      <Routes>
        <Route path="/" exact element={<Home ref={titleRef} />} />
      </Routes>
      {/* {false && <Route path="/blog" exact component={Blog} />}
      {false && <Route path="/blog/:id" component={BlogPost} />} */}
      <Footer>
        {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )}
      </Footer>
    </BrowserRouter>
  );
};

export default App;
